import { BREAKPOINT_MEDIUM } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #fff5d8;
  border-radius: 10px;
  padding: 25px;
  box-sizing: border-box;
  position: sticky;
  top: 110px;

  p {
    line-height: 1.4;
  }

  &:before {
    content: '';
    display: block;
    border-right: 12px solid #fff5d8;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    position: absolute;
    top: 28px;
    left: -12px;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    position: relative;
    top: 0;
    grid-row-start: 1;
    padding: 18px;

    &:before {
      content: none;
    }
  }
`

export const Header = styled.ul`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;

  svg {
    width: 18px;
    height: 18px;
  }
`
export const TickList = styled.ul`
  display: grid;
  grid-template-columns: 100%;
  gap: 10px;
  margin-top: 15px;
`
export const MobileTick = styled.li`
  display: none;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
  line-height: 1.3;

  &:before {
    content: '';
    display: block;
    width: 10px;
    height: 4px;
    border-bottom: 2px solid var(--text-primary);
    border-left: 2px solid var(--text-primary);
    transform: rotate(-45deg);
    position: relative;
    top: 5px;
    flex-shrink: 0;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    display: flex;
  }
`
export const DesktopTick = styled(MobileTick)`
  display: flex;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    display: none;
  }
`
